<template>
    <div class="hover_buttons d-inline-flex">
        <a
            href="#"
            data-toggle="modal"
            v-if="!isAuthenticatedClient"
            v-tooltip="'Add to favorite!'"
            :data-path="$route.path"
            data-target="#login"
            class="favorite_button bg_primary_orange py_18 px_14"
        >
            <img src="/maincss/images/favorite_button.svg" alt=" " />
        </a>
        <a
            v-else-if="is_favorite_product"
            v-tooltip="'Favorite product!'"
            class="favorite_button bg_primary_orange py_18 px_14 dark-orange-backgornd"
            @click="!isBusy ? removeFromFavorite(favorite_product) : ''"
        >
            <img
                class="red_heart"
                src="/maincss/images/heart_red.svg"
                alt=" "
            />
            <img
                class="white_heart"
                src="/maincss/images/favorite_button.svg"
                alt=" "
            />
        </a>
        <a
            v-else-if="!is_favorite_product"
            @click="addToFavorite(product)"
            class="favorite_button bg_primary_orange py_18 px_14"
        >
            <img src="/maincss/images/favorite_button.svg" alt=" " />
        </a>

        <router-link
            :to="{
                name: 'product_details_new',
                params: { id_of_product: product.id }
            }"
            class="addcart_button bg_primary_orange py_18 w-100 text-center mx_10 text_white heading5 d-flex justify-content-center align-items-center"
        >
            View Details
        </router-link>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
export default {
    name: "ProductBottomLink",
    props: {
        product: {
            required: true
        }
    },
    data() {
        return {
            isBusy: false,
            favorite_product: [],
            is_favorite_product: false
        };
    },
    computed: {
        ...mapGetters(["isAuthenticatedClient", "currentUserClient"]),
        tag() {
            return this.$route.params.tag;
        }
    },
    methods: {
        discountedPrice(product) {
            let promotion_values = product.MainNewProductDiscounts;
            let final_price = 0;
            if (!promotion_values) {
                return final_price;
            }
            let retail_price = Number(this.getRetailPrice(product));
            let discount_value = Number(promotion_values.discount_value);
            if (promotion_values.discount_type == "Percent") {
                final_price = retail_price * ((100 - discount_value) / 100);
            } else {
                final_price = retail_price - discount_value;
            }

            return final_price;
        },
        removeFromFavorite(favorite_product) {
            console.log(favorite_product);
            var _this = this;
            if (favorite_product && favorite_product.id) {
                new Promise((resolve, reject) => {
                    _this.isBusy = true;
                    ApiService.post("/delete/favorite-product", {
                        ids: favorite_product.id
                    })
                        .then(({ data }) => {
                            if (data.success) {
                                _this.$toast.error(
                                    "Product removed from your favorite list.",
                                    {
                                        position: "top-right",
                                        queue: true
                                    }
                                );
                                _this.$emit("updateFavourites");
                                _this.is_favorite_product = false;
                                _this.isBusy = false;
                                // _this.getFavoriteProduct(_this.product);
                            }
                            resolve(data);
                        })
                        .catch(({ response }) => {
                            console.log(response);
                            reject(response);
                        });
                });
            }
        },
        getFavoriteProduct() {
            let product = this.product;
            var _this = this;
            if (_this.currentUserClient.id) {
                new Promise((resolve, reject) => {
                    _this.isBusy = true;
                    ApiService.get("/favorite-product/" + product.id)
                        .then(({ data }) => {
                            _this.favorite_product = data.favorite_product;
                            _this.is_favorite_product = data.favorite_product.id
                                ? true
                                : false;
                            _this.isBusy = false;
                            resolve(data);
                        })
                        .catch(({ response }) => {
                            console.log(response);
                            reject(response);
                        });
                });
            }
        },
        addToFavorite(product) {
            var _this = this;
            new Promise((resolve, reject) => {
                let post_data = { product_id: product.id };
                ApiService.post("/favorite-product", post_data)
                    .then(({ data }) => {
                        if (data.success) {
                            _this.is_favorite_product = true;
                            _this.$emit("updateFavourites");
                            _this.$toast.success(data.message, {
                                position: "top-right",
                                queue: true
                            });
                            resolve(data);
                        } else {
                            _this.$toast.error(data.error, {
                                position: "top-right",
                                queue: true
                            });
                            reject(data);
                        }
                    })
                    .catch(({ response }) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getRetailPrice(product) {
            let product_cost = product.price_base;
            let markup_value = product.price_markup_value;
            let price_color_category_dark = product.price_color_category_dark;
            let price_color_category_light = product.price_color_category_light;
            let single_location_cost = 0;
            if (product.decoration_flag == 1) {
                if (product.decoration_type == 1 || product.decoration_type == 5) {
                    single_location_cost = JSON.parse(
                        product.price_decoration_bulk
                    )["print_location1"][0]["colour1"];
                } else {
                    single_location_cost = JSON.parse(
                        product.price_decoration_bulk
                    )[0]["cost"];
                }
            }
            let retail_price = parseFloat(
                parseFloat(product_cost) +
                    parseFloat(markup_value) +
                    parseFloat(price_color_category_dark) +
                    parseFloat(price_color_category_light) +
                    parseFloat(single_location_cost)
            ).toFixed(2);
            if (isNaN(retail_price)) {
                retail_price = 0.0;
            }
            return retail_price;
        }
    }
};
</script>
